import React from "react";

import { Box, Grid, Typography } from "@material-ui/core";

import {
  Labeled,
  required,
  SelectInput,
  TextField,
  TextInput,
} from "react-admin";

import { AppType, CountryList } from "../../../utils/constants";
import { ClipboardTextField } from "../../../components/common/CopyToClipboardButton";
import { formatPhoneNumber } from "../../../utils/utils";

export const ContactInfo = ({ classes, disabled, record, ...props }) => {
  if (disabled) {
    return <ContactInfoSHow {...props} classes={classes} record={record} />;
  }
  return <ContactInfoForm {...props} />;
};

const ContactInfoForm = ({ ...props }) => {
  return (
    <Box flexWrap="wrap" flex={1} mt={"2em"} style={{ width: "100%" }}>
      <Box display={{ xs: "block", sm: "flex" }}>
        <Box flex={1} mr={{ xs: 0, sm: "1em" }}>
          <TextInput
            source="name"
            label="Business name"
            variant="outlined"
            fullWidth
            autoFocus
            validate={required()}
          />
        </Box>
        <Box flex={1}>
          <TextInput
            source="website"
            label="Website"
            variant="outlined"
            fullWidth
          />
        </Box>
      </Box>
      <Box display={{ xs: "block", sm: "flex" }}>
        <Box flex={1} mr={{ xs: 0, sm: "1em" }}>
          <TextInput
            source="phone"
            label="Phone"
            variant="outlined"
            fullWidth
            validate={required()}
          />
        </Box>
        <Box flex={1}>
          <TextInput source="fax" label="Fax" variant="outlined" fullWidth />
        </Box>
      </Box>
      <Box display={{ xs: "block", sm: "flex" }}>
        <Box flex={0.5} mr={{ xs: 0, sm: "1em" }}>
          <TextInput
            source="email"
            label="Email"
            variant="outlined"
            type="email"
            fullWidth
            parse={(v) => (v !== "" ? v.toLowerCase() : undefined)}
            validate={required()}
          />
        </Box>
      </Box>
      <Box mb={2} flex={1}>
        <Typography variant="overline" color="textSecondary" gutterBottom>
          Address
        </Typography>
      </Box>
      <Box display={{ xs: "block", sm: "flex" }}>
        <Box flex={1} mr={{ xs: 0, sm: "1em" }}>
          <TextInput
            fullWidth
            source="street"
            label="Street"
            variant="outlined"
            validate={required()}
          />
        </Box>
        <Box flex={1}>
          <TextInput
            fullWidth
            source="city"
            label="City"
            variant="outlined"
            validate={required()}
          />
        </Box>
      </Box>
      <Box display={{ xs: "block", sm: "flex" }}>
        <Box flex={1} mr={{ xs: 0, sm: "1em" }}>
          <TextInput
            fullWidth
            source="state"
            label="State/Province"
            variant="outlined"
            validate={required()}
            inputProps={{
              maxLength: 2,
              style: { textTransform: "uppercase" },
            }}
          />
        </Box>
        <Box flex={1}>
          <TextInput
            fullWidth
            source="zipCode"
            label="Postal Code"
            variant="outlined"
            validate={required()}
          />
        </Box>
        <Box flex={1}>
          <SelectInput
            source="country"
            label="Country"
            choices={CountryList}
            optionText="name"
            optionValue="id"
            variant="outlined"
            fullWidth
            validate={required()}
          />
        </Box>
      </Box>
    </Box>
  );
};

const ContactInfoSHow = ({ classes, record, ...props }) => {
  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={12} md={6}>
          <Labeled label="Name">
            <TextField source="name" record={record} />
          </Labeled>
        </Grid>
        <Grid item xs={12} md={6}>
          <Labeled label="Website">
            <TextField source="website" record={record} />
          </Labeled>
        </Grid>
        <Grid item xs={12} md={6}>
          {window.appUser?.appType === AppType.ADMIN ? (
            <ClipboardTextField
              source="phone"
              label="Phone"
              record={record}
              format={(val) => val && formatPhoneNumber(val)}
            />
          ) : (
            <Labeled label="Phone">
              <TextField source="phone" record={record} />
            </Labeled>
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          <Labeled label="Fax">
            <TextField source="fax" record={record} />
          </Labeled>
        </Grid>
        <Grid item xs={12} md={6}>
          <Labeled label="Email">
            <TextField source="email" record={record} />
          </Labeled>
        </Grid>
        <Grid item xs={12} md={6}></Grid>
        <Grid item xs={12} md={6}>
          <Labeled label="Street">
            <TextField source={"street"} record={record} />
          </Labeled>
        </Grid>
        <Grid item xs={12} md={6}>
          <Labeled label="City">
            <TextField source={"city"} record={record} />
          </Labeled>
        </Grid>
        <Grid item xs={12} md={4}>
          <Labeled label="State/Province">
            <TextField source={"state"} record={record} />
          </Labeled>
        </Grid>
        <Grid item xs={12} md={4}>
          <Labeled label="Postal Code">
            <TextField source={"zipCode"} record={record} />
          </Labeled>
        </Grid>
        <Grid item xs={12} md={4}>
          <Labeled label="Country">
            <TextField source={"country"} record={record} />
          </Labeled>
        </Grid>
      </Grid>
    </div>
  );
};
